module.exports = __webpack_public_path__ + "static/pic01-937e606bde5b71d18460134ade0bd7a1.jpg";